import { createContext, useContext, useEffect } from 'react';

type PageContainerRefreshFn = () => unknown;
type PageContainerRegisterRefreshHandler = (
  handler: PageContainerRefreshFn | null,
) => void;

export const PageContainerRefreshHandlerContext =
  createContext<PageContainerRegisterRefreshHandler | null>(null);

export function useRegisterPageRefreshHandler(
  handler: PageContainerRefreshFn | null,
) {
  const register = useContext(PageContainerRefreshHandlerContext);
  useEffect(() => {
    register?.(handler);
    return () => {
      register?.(null);
    };
  }, [handler, register]);
}
